<app-native-take-photo-result *ngIf="isWrapping"></app-native-take-photo-result>
<app-native-barcode-reader-input *ngIf="isWrapping"></app-native-barcode-reader-input>
<app-sumup-callback-input></app-sumup-callback-input>

<div class="container">
    <ng-template #loading>
        <app-preloader></app-preloader>
    </ng-template>

    <ngb-alert
        *ngIf="myTasksService.hasMessage | async"
        [type]="(myTasksService.flashMessage | async).type"
        (close)="myTasksService.hideFlashMessage()"
    >
        <strong>{{ (myTasksService.flashMessage | async).title }}</strong>
        {{ (myTasksService.flashMessage | async).message }}
    </ngb-alert>

    <div
        class="row"
        *ngIf="!(myTasksService.isGettingTasksInProgress | async); else loading"
    >
        <div
            *ngIf="!isNativeAppTrackingStarted; else tasksVisibleContainer"
            class="text-center w-100"
        >
            <button class="btn btn-success m-2 p-2 w-75" (click)="confirmWorkTimeStart()">
                {{ 'my-tasks.start-worktime-tracking' | translate }}
            </button>
            <hr class="w-75" />
        </div>

        <ng-template #tasksVisibleContainer>
            <section class="dynamic-tasks-view w-100">
                <div class="dynamic-worktime-actions">
                    <button
                        class="btn dynamic-stop-button"
                        (click)="myTasksService.stopAppGPSTracking()"
                    >
                        <i class="fa fa-stop-circle" aria-hidden="true"></i>
                        {{ 'my-tasks.stop-worktime-tracking' | translate }}
                    </button>
                    <button class="btn dynamic-refresh-button" (click)="refreshTasks()">
                        <i class="fa fa-refresh" aria-hidden="true"></i>
                        {{ 'common.refresh-tasks' | translate }}
                    </button>
                    <ng-container *ngIf="showFindNextTaskButton">
                        <button
                            *ngIf="!(myTasksService.isNextTaskFindingInProgress | async)"
                            class="btn dynamic-find-task-button"
                            (click)="myTasksService.getNextTask()"
                        >
                            <i class="fa fa-search" aria-hidden="true"></i>
                            {{ 'my-tasks.find-next-task' | translate }}
                        </button>
                        <button
                            *ngIf="myTasksService.isNextTaskFindingInProgress | async"
                            class="btn dynamic-find-task-button disabled"
                            disabled
                        >
                            <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                            {{ 'my-tasks.find-next-task-in-progress' | translate }}
                        </button>
                    </ng-container>
                </div>

                <section
                    *ngIf="unplannedTaskGroup"
                    class="card border-0 rounded shadow-sm dynamic-worktime-block"
                >
                    <div
                        class="dynamic-active-worktime mb-0"
                        role="button"
                        tabindex="0"
                        [attr.aria-expanded]="!unplannedIsCollapsed"
                        (click)="toggleUnplannedGroup()"
                        (keydown.enter)="toggleUnplannedGroup()"
                        (keydown.space)="$event.preventDefault(); toggleUnplannedGroup()"
                    >
                        <span class="dynamic-group-corner-badges">
                            <span
                                class="dynamic-task-type-count dynamic-group-total-count"
                            >
                                {{ unplannedTotalTaskCount }}
                                {{ 'my-tasks.task-count' | translate }}
                            </span>
                            <span
                                class="dynamic-task-type-count dynamic-collecting-task-count"
                                [attr.aria-label]="
                                    ('my-tasks.collecting-task-count' | translate) +
                                    ': ' +
                                    unplannedCollectingTaskCount
                                "
                            >
                                {{ unplannedCollectingTaskCount }}
                            </span>
                            <span
                                class="dynamic-task-type-count dynamic-delivering-task-count"
                                [attr.aria-label]="
                                    ('my-tasks.delivering-task-count' | translate) +
                                    ': ' +
                                    unplannedDeliveringTaskCount
                                "
                            >
                                {{ unplannedDeliveringTaskCount }}
                            </span>
                            <span
                                class="dynamic-task-type-count dynamic-refunding-task-count"
                                [attr.aria-label]="
                                    'ItemsRefunding: ' + unplannedRefundingTaskCount
                                "
                            >
                                {{ unplannedRefundingTaskCount }}
                            </span>
                        </span>
                        <strong class="dynamic-worktime-label">
                            {{ 'my-tasks.unplanned-tasks' | translate }}
                        </strong>
                        <div class="dynamic-worktime-icons">
                            <button
                                type="button"
                                class="btn dynamic-map-button"
                                [disabled]="!unplannedHasDoneTasks"
                                (click)="
                                    $event.stopPropagation();
                                    toggleUnplannedCompletedTasks()
                                "
                                [attr.aria-label]="
                                    (unplannedHideDone
                                        ? 'my-tasks.show-completed-tasks'
                                        : 'my-tasks.hide-completed-tasks'
                                    ) | translate
                                "
                            >
                                <i
                                    class="fa"
                                    [ngClass]="
                                        unplannedHideDone ? 'fa-eye' : 'fa-eye-slash'
                                    "
                                    aria-hidden="true"
                                ></i>
                            </button>
                            <i
                                class="fa dynamic-worktime-collapse-icon"
                                [ngClass]="
                                    unplannedIsCollapsed ? 'fa-angle-down' : 'fa-angle-up'
                                "
                                aria-hidden="true"
                            ></i>
                        </div>
                    </div>
                    <div
                        task-group
                        [taskGroup]="unplannedTaskGroup"
                        [isCollapsed]="unplannedIsCollapsed"
                        [hasFrame]="false"
                        [useDynamicRouting]="true"
                        [hideDone]="unplannedHideDone"
                        [badgeText]="'my-tasks.unplanned' | translate"
                        class="task-group-column dynamic-task-group col-12"
                        [ngClass]="unplannedIsCollapsed ? 'p-0' : 'pt-0 px-3 pb-3'"
                    ></div>
                </section>

                <section
                    *ngFor="let block of worktimeTaskBlocks"
                    class="card border-0 rounded shadow-sm dynamic-worktime-block"
                >
                    <div
                        class="dynamic-active-worktime mb-0"
                        role="button"
                        tabindex="0"
                        [attr.aria-expanded]="!block.isCollapsed"
                        (click)="toggleWorktimeBlock(block.worktime.id)"
                        (keydown.enter)="toggleWorktimeBlock(block.worktime.id)"
                        (keydown.space)="
                            $event.preventDefault();
                            toggleWorktimeBlock(block.worktime.id)
                        "
                    >
                        <span class="dynamic-group-corner-badges">
                            <span
                                class="dynamic-task-type-count dynamic-group-total-count"
                            >
                                {{ block.totalTaskCount }}
                                {{ 'my-tasks.task-count' | translate }}
                            </span>
                            <span
                                class="dynamic-task-type-count dynamic-collecting-task-count"
                                [attr.aria-label]="
                                    ('my-tasks.collecting-task-count' | translate) +
                                    ': ' +
                                    block.collectingTaskCount
                                "
                            >
                                {{ block.collectingTaskCount }}
                            </span>
                            <span
                                class="dynamic-task-type-count dynamic-delivering-task-count"
                                [attr.aria-label]="
                                    ('my-tasks.delivering-task-count' | translate) +
                                    ': ' +
                                    block.deliveringTaskCount
                                "
                            >
                                {{ block.deliveringTaskCount }}
                            </span>
                        </span>
                        <div>
                            <strong class="dynamic-worktime-label">
                                {{
                                    (block.worktime.isActive
                                        ? 'my-tasks.active-worktime'
                                        : 'my-tasks.old-worktime'
                                    ) | translate
                                }}:
                            </strong>
                            <strong>
                                {{ block.worktime.start | amDateFormat : 'H.mm' }}
                                &ndash;
                                {{ block.worktime.end | amDateFormat : 'H.mm' }}
                            </strong>
                        </div>
                        <div class="dynamic-worktime-icons">
                            <button
                                type="button"
                                class="btn dynamic-map-button"
                                [disabled]="!block.worktime.supplierRegionID"
                                (click)="
                                    $event.stopPropagation();
                                    openLogisticsMap(block.worktime.supplierRegionID)
                                "
                                [attr.aria-label]="
                                    'supplier-resources.open-logistics-map' | translate
                                "
                            >
                                <i class="fa fa-map-o" aria-hidden="true"></i>
                            </button>
                            <button
                                type="button"
                                class="btn dynamic-map-button"
                                [disabled]="!block.hasDoneTasks"
                                (click)="
                                    $event.stopPropagation();
                                    toggleCompletedTasks(block.worktime.id)
                                "
                                [attr.aria-label]="
                                    (block.hideDone
                                        ? 'my-tasks.show-completed-tasks'
                                        : 'my-tasks.hide-completed-tasks'
                                    ) | translate
                                "
                            >
                                <i
                                    class="fa"
                                    [ngClass]="block.hideDone ? 'fa-eye' : 'fa-eye-slash'"
                                    aria-hidden="true"
                                ></i>
                            </button>
                            <i
                                class="fa dynamic-worktime-collapse-icon"
                                [ngClass]="
                                    block.isCollapsed ? 'fa-angle-down' : 'fa-angle-up'
                                "
                                aria-hidden="true"
                            ></i>
                        </div>
                    </div>

                    <div
                        task-group
                        [taskGroup]="block.taskGroup"
                        [isCollapsed]="block.isCollapsed"
                        [hasFrame]="false"
                        [useDynamicRouting]="true"
                        [hideDone]="block.hideDone"
                        [showCollectingDividers]="true"
                        class="task-group-column dynamic-task-group col-12"
                        [ngClass]="block.isCollapsed ? 'p-0' : 'pt-0 px-3 pb-3'"
                    ></div>
                </section>

                <div
                    *ngIf="taskList?.additionalWorktimes?.length"
                    class="dynamic-additional-worktimes"
                >
                    <span>
                        {{ 'my-tasks.additional-worktimes-today' | translate }}:
                    </span>
                    <strong
                        *ngFor="
                            let worktime of taskList.additionalWorktimes;
                            let isLast = last
                        "
                    >
                        {{ worktime.start | amDateFormat : 'H.mm' }} &ndash;
                        {{ worktime.end | amDateFormat : 'H.mm' }}
                        {{ 'my-tasks.hour' | translate }}<span *ngIf="!isLast">, </span>
                    </strong>
                </div>

                <h2 *ngIf="nonTodayTaskGroups.length" class="dynamic-section-title">
                    {{ 'my-tasks.non-today-tasks' | translate }}
                </h2>

                <div
                    task-group
                    *ngFor="let taskGroup of nonTodayTaskGroups"
                    [taskGroup]="taskGroup"
                    [isCollapsed]="isNonTodayGroupCollapsed(taskGroup)"
                    (toggleRequested)="toggleNonTodayGroup(taskGroup)"
                    [hasFrame]="true"
                    [useDynamicRouting]="true"
                    [showTaskBadges]="false"
                    class="task-group-column dynamic-task-group col-12"
                ></div>
            </section>

            <div class="dynamic-multi-picking-footer">
                <div
                    class="dynamic-summary-row"
                    [class.has-price]="isCalculatedPriceVisible"
                >
                    <a
                        class="btn dynamic-partner-stores-button"
                        [href]="taskList?.partnerStoresMapUrl"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <i class="fa fa-map-o" aria-hidden="true"></i>
                        {{ 'my-tasks.partner-stores' | translate }}
                    </a>
                    <button
                        *ngIf="isCalculatedPriceVisible"
                        type="button"
                        class="btn dynamic-price-button"
                        (click)="showCalculatedPriceInfoModal()"
                    >
                        <i class="fa fa-money" aria-hidden="true"></i>
                        {{ calculatedPrice }}
                        {{ 'common.currency' | translate }}
                        <i class="fa fa-info-circle" aria-hidden="true"></i>
                    </button>
                </div>
                <button
                    *ngIf="maximumMultipickingTasks > 1"
                    class="btn dynamic-multi-picking-button"
                    [class.is-disabled]="multiPickingSelectedTasks?.length <= 1"
                    (click)="startMultipicking()"
                >
                    <span *ngIf="!multiPickingAlreadyInProgress">
                        <i class="fa fa-play" aria-hidden="true"></i>
                        {{ 'my-tasks.start-multipicking-tasks' | translate }}
                    </span>
                    <span *ngIf="multiPickingAlreadyInProgress">
                        <i class="fa fa-forward" aria-hidden="true"></i>
                        {{ 'my-tasks.continue-multipicking-tasks' | translate }}
                    </span>
                    <span class="badge badge-primary shadow-sm">
                        {{ maximumMultipickingTasks }}/{{
                            multiPickingSelectedTasks?.length
                        }}
                    </span>
                </button>
            </div>
        </ng-template>
    </div>
</div>

<ng-template #logisticsMapModal let-modal>
    <div class="modal-header modal-fullscreen">
        <h4 class="modal-title" id="my-tasks-logistics-map-modal-title">
            {{ 'supplier-resources.logistics-map' | translate }}
        </h4>
        <button
            type="button"
            class="close"
            aria-label="Close button"
            aria-describedby="my-tasks-logistics-map-modal-title"
            (click)="modal.dismiss('Cross click')"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body logistics-map-modal-body p-0">
        <iframe
            *ngIf="logisticsMapUrl"
            [src]="logisticsMapUrl"
            class="logistics-map-iframe"
            title="logistics-map"
        ></iframe>
    </div>
</ng-template>

<app-task-failed-modal (onTaskFailSet)="onTaskFailSet($event)"></app-task-failed-modal>
<app-package-verify-modal></app-package-verify-modal>
<app-calculated-price-info-modal></app-calculated-price-info-modal>

<lib-modal
    [title]="'my-tasks.out-of-shop-location-modal-title' | translate"
    [componentID]="'out-of-shop-location-modal'"
>
    <p>
        {{ 'my-tasks.out-of-shop-location-modal-text' | translate }}
    </p>
    <button
        type="button"
        class="btn btn-warning"
        (click)="modalService.setModalVisibility(false, 'out-of-shop-location-modal')"
    >
        OK
    </button>
</lib-modal>

<lib-modal
    [title]="'my-tasks.start-worktime-control-message' | translate"
    [componentID]="'start-worktime-control'"
    [bgColorClass]="'danger'"
    [hasCloseIcon]="false"
>
    <ng-container *ngIf="notCompletedStartControl">
        <div class="w-100">
            <h2 class="text-left">
                {{ notCompletedStartControl.text }}
            </h2>
        </div>

        <div class="photo-thumbnail-container ml-auto mr-auto">
            <img
                class="img-thumbnail d-block mr-auto ml-auto"
                [src]="
                    imgResultAfterCompression ??
                    notCompletedStartControl.photoPlaceholderUrl
                "
            />
        </div>
        <div
            class="file-input"
            *ngIf="!photoLoaded && notCompletedStartControl.isPhotoRequired"
        >
            <input
                *ngIf="!isNewWrapper"
                type="file"
                accept="image/*"
                capture="environment"
                id="photo-input"
                onclick="this.value = null"
                (change)="onPhotoInputChanged($event)"
                hidden
            />
            <label
                class="photo-btn btn btn-block btn-info"
                for="photo-input"
                (click)="handleTakeAPhoto()"
            >
                <i class="fa fa-camera"></i>
                {{ 'collecting.photo-upload' | translate }}
            </label>
            <div *ngIf="isPhotoInvalid" class="text-danger text-center">
                <div>
                    {{ 'collecting.photo-upload' | translate }}
                    {{ 'common.is-required' | translate }}
                </div>
            </div>
        </div>
        <hr />
        <div
            *ngIf="notCompletedStartControl.isAdditionalInfoRequired"
            class="w-100 mt-4 mb-4"
        >
            <input
                type="text"
                id="additionalInfo"
                [(ngModel)]="additionalInfo"
                class="form-control"
                placeholder="{{ notCompletedStartControl.additionalInfoPlaceholder }}"
                autofocus
            />
            <div *ngIf="isAdditionalInfoInvalid" class="text-danger text-center">
                <div>
                    {{ notCompletedStartControl.additionalInfoPlaceholder }}
                    {{ 'common.is-required' | translate }}
                </div>
            </div>
        </div>

        <div class="text-center w-100">
            <button
                class="btn btn-success w-75 mb-4"
                *ngIf="!isControlSaveBlocked"
                (click)="addComletedStartControl()"
            >
                {{ 'common.save' | translate }}
            </button>
            <button
                class="btn btn-secondary w-75"
                (click)="
                    modalService.setModalVisibility(false, 'start-worktime-confirm');
                    this.resetAll()
                "
            >
                {{ 'common.cancel' | translate }}
            </button>
        </div>
    </ng-container>
</lib-modal>

<lib-modal
    [title]="'my-tasks.are-you-sure-starting-your-work' | translate"
    [componentID]="'start-worktime-confirm'"
    [bgColorClass]="'info'"
>
    <div class="w-100">
        <p class="text-center">
            {{ 'my-tasks.to-start-work-message' | translate }}
        </p>
    </div>
    <div class="text-center w-100">
        <button
            class="btn btn-success w-75 mb-4"
            (click)="myTasksService.startAppGPSTracking()"
        >
            {{ 'common.yes' | translate }}
        </button>
        <button
            class="btn btn-secondary w-75"
            (click)="modalService.setModalVisibility(false, 'start-worktime-confirm')"
        >
            {{ 'common.cancel' | translate }}
        </button>
    </div>
</lib-modal>

<br /><br /><br /><br />
